export default {
  "Ca_Val": 'Ca',
  "Mg_Val": 'Mg',
  "S_Val": 'S',
  "B_Val": 'B',
  "Fe_Val": 'Fe',
  "Mn_Val": 'Mn',
  "Zn_Val": 'Zn',
  "Cu_Val": 'Cu',
  "Mo_Val": 'Mo',
  "CL_Val": 'CL',
  "Na_Val": 'Na',
  "HCO3_Val": 'HCO3',
  "N_Val": 'N',
  "P_Val": 'P',
  "K_Val": 'K',
  "NO3_Val": 'NNO3',
  "NH4_Val": 'NNH4',
  "NH2_Val": 'NNH2',
  "CO3_Val": 'CO3',
  "F_Val": 'F',
  "Al_Val": 'Al',
  "Cl_Val": 'Cl'
}
